module.exports = __webpack_public_path__ + "static/media/Engpic2@3x.9cd95171.png";